export default "__VITE_ASSET__DPJX2sTI__"